import { useCallback, useEffect, useRef, useState } from "react";

export const useInterval = (
    callback: () => void,
    initialDelay?: number,
    autoStart = true,
) => {
    const savedCallback = useRef<() => void>(null);
    const [delay, setDelay] = useState<number | undefined>(initialDelay);
    const [delayVersion, setDelayVersion] = useState(0);
    const timerId = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        clearTimer();

        function tick() {
            savedCallback.current?.();
        }

        function clearTimer() {
            if (timerId.current) {
                clearInterval(timerId.current);
                timerId.current = null;
            }
        }

        if (autoStart) tick();

        if (delay) {
            timerId.current = setInterval(tick, delay);
        }
        return () => {
            clearTimer();
        };
    }, [delay, autoStart, delayVersion]);

    const reschedule = useCallback((newDelay?: number) => {
        setDelay(newDelay);
        setDelayVersion((v) => v + 1);
    }, []);

    return { reschedule };
};
